import { Typography, Grid, Card, CardContent, Container } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import IncomeFinance from "./IncomeFinance";
import ExpenseFinance from "./ExpenseFinance";
import { useToast } from "../../components/Toast";
import NavigationHeader from "../../components/NavigationHeader";
import CashBook from "./CashBook";

// Finance Categories
const FinanceCategories = [
  {
    id: "income",
    title: "Receivables",
    description: "Receivables from various sources",
  },
  {
    id: "expense",
    title: "Payables",
    description: "Payables to various sources",
  },
  {
    id: "cashbook",
    title: "Cashbook",
    description: "All your transactions will be shown here",
  },
];

const Finance = () => {
  const { financeType } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      {!financeType && (
        <>
          <NavigationHeader
            title="Finance Management"
            backNavigationEnabled={false}
          />
          <Grid container spacing={2}>
            {FinanceCategories.map((category) => (
              <Grid item xs={12} sm={4} key={category.id}>
                <Card
                  sx={{
                    height: "100%",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: 4,
                    },
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate(`/finance/${category.id}`);
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">{category.title}</Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {category.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      )}
      {financeType === "income" && <IncomeFinance />}
      {financeType === "expense" && <ExpenseFinance />}
      {financeType === "cashbook" && <CashBook />}
    </Container>
  );
};

export default Finance;
